import React, { CSSProperties } from 'react';

import { Box, Button, Typography } from '@mui/material';

import { UnAvailableButtonStyled } from './style';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import NextLink from '@components/atoms/link';

interface Props {
  icon: string;
  title: string;
  subtitle: string;
  style?: CSSProperties;
  isFooter?: boolean;
  link?: string;
  hideButton?: boolean;
}

const UnAvailableButton = ({ icon, title, subtitle, style, isFooter, link, hideButton }: Props) => (
  <UnAvailableButtonStyled style={{ ...style }} isFooter={isFooter}>
    <Box className="container-box">
      <Box sx={{ mr: { md: 2, xs: 1.5 } }}>
        <FontAwesomeIcon icon={icon} className="cannot-train-icon" />
      </Box>
      <Box>
        <Typography
          component="p"
          className="title-text"
          sx={{ typography: { md: isFooter ? 'h7' : 'h4', xs: isFooter ? 'h11' : 'h7' } }}
        >
          {title}
        </Typography>
        {!hideButton && link && (
          <NextLink href={link}>
            <Button
              variant="text"
              className="link-button"
              sx={{
                color: 'white',
                p: 0,
                typography: 'h7',
                width: { lg: 'auto' },
                fontSize: { md: '18px', xs: '14px' },
              }}
            >
              {subtitle}
              <FontAwesomeIcon icon="fa-light fa-arrow-right-long" style={{ marginLeft: 6 }} />
            </Button>
          </NextLink>
        )}
      </Box>
    </Box>
  </UnAvailableButtonStyled>
);

export default UnAvailableButton;
